import axiosInstance from "../utils/axios"

/* TODO:
  resync caso erro 403 no workspace
*/

const getSession = () => {
  const itemSession = localStorage.getItem("session")
  if (!itemSession) {
    clearSession()
    return {}
  }

  return JSON.parse(itemSession + "")
}

const updateSession = (data = {}) => {
  const itemSession = JSON.parse(localStorage.getItem("session"))

  localStorage.setItem("session", JSON.stringify(Object.assign(itemSession, data)))
}

const clearSession = () => {
  localStorage.clear()
}

const getPermissions = (name) => {
  const itemPermissions = localStorage.getItem("permissions")
  if (!itemPermissions) {
    return false
  }

  const permissions = JSON.parse(itemPermissions + "")

  if (name) {
    return permissions.find((route) => route.name === name)?.is_allowed
  }

  return permissions
}

// For hiding what the role cannot do. Api() below does not stop a denied call once a workspace
// is selected, so screens check this. A name missing from the list is left to the API to refuse.
const isAllowed = (name) => {
  const permissions = getPermissions()
  const permission = Array.isArray(permissions) && permissions.find((route) => route.name === name)

  return permission ? permission.is_allowed === true : true
}

const accessToken = () => {
  const currentSession = getSession()
  if (currentSession?.access_token) {
    return currentSession.access_token
  }
}

const urlWithAccessToken = (url) => url + `?access-token=${accessToken()}`

const urlWithSignerAccessCode = (url, signerAccessCode) => url + `?signer-access-code=${signerAccessCode}`

const setSession = (response, resolve) => {
  const {
    data: {
      data,
      data: { accounts },
    },
  } = response

  localStorage.setItem("session", JSON.stringify(data))

  if (accounts && accounts.length) {
    Api("authorization/permissionIndex")(accounts[0].id)
      .then(({ data: { data } }) => {
        localStorage.setItem("permissions", JSON.stringify(data))

        resolve(response.data)
      })
      .catch(() => {
        localStorage.setItem("permissions", JSON.stringify([]))

        resolve(response.data)
      })
  } else {
    resolve(response.data)
  }
}

const isMfaChallenge = (response) => (
  response?.data?.data?.mfa_required === true || response?.data?.mfa_required === true
)

const resolveAuthentication = (response, resolve) => {
  if (isMfaChallenge(response)) {
    resolve(response.data)
    return
  }

  setSession(response, resolve)
}

const login = async (credentials) => {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "POST",
      url: "/login",
      data: credentials,
    })
      .then((resp) => {
        resolveAuthentication(resp, resolve)
      })
      .catch((error) => {
        clearSession()
        reject(error)
      })
  })
}

const downloadFileBlob = async (url) =>
  axiosInstance({
    type: "GET",
    url: url,
    responseType: "blob",
  })

const downloadFile = async (url) => {
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", "")
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const updateAccounts = async (resp, resolve, callback) => {
  Api("accountUser/index")().then(({ status, data: { data } }) => {
    if (status === 200) {
      updateSession({
        accounts: data,
      })

      if (callback) {
        callback()
      }

      if (resolve) {
        resolve(resp)
      }
    }
  })
}

const selectAccount = (id, callbackThen, callbackCatch) => {
  return new Promise((resolve, reject) => {
    Api("account/view")(id)
      .then((resp) => {
        if (resp.status === 200) {
          Api("authorization/permissionIndex")(id).then(({ data: { data } }) => {
            localStorage.setItem("permissions", JSON.stringify(data))

            updateAccounts(resp.data, resolve, callbackThen)
          })
        }
      })
      .catch((error) => {
        callbackCatch("Não foi possível acessar o workspace selecionado.")
        reject(error)
      })
  })
}

const selfUpdates = (callback) => {
  return Api("user/getSelf")().then(
    ({
      status,
      data: {
        data: { user },
      },
    }) => {
      if (status === 200) {
        updateSession({
          user,
        })

        if (callback) {
          callback(user)
        }

        return user
      }
    },
  )
}

// Request under the current workspace: /accounts/{id}{path}. Rejects without one, so callers
// can chain on the promise.
const accountRequest = (path, config = {}) => {
  const currentAccount = getSession().accounts?.[0]
  if (!currentAccount) {
    return Promise.reject({ response: { data: { message: "Selecione um workspace." } } })
  }

  return axiosInstance({ ...config, url: `/accounts/${currentAccount.id}${path}` })
}

const contractUrl = (documentId, action = "") => `/documents/${documentId}/contract${action}`

const Endpoints = {
  "document/index": {
    required_login: true,
    required_workspace: true,
    fn: async (config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            url: `/accounts/${currentAccount.id}/documents`,
          },
          config,
        ),
      )
    },
  },
  "document/search": {
    required_login: true,
    required_workspace: true,
    fn: async (config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            url: `/accounts/${currentAccount.id}/documents/search`,
          },
          config,
        ),
      )
    },
  },
  "document/view": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            url: `/documents/${documentId}`,
          },
          config,
        ),
      )
    },
  },
  "document/delete": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "DELETE",
            url: `/documents/${documentId}`,
          },
          config,
        ),
      )
    },
  },
  "document/update": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, data, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PATCH",
            data,
            url: `/documents/${documentId}`,
          },
          config,
        ),
      )
    },
  },
  "documentTag/index": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            url: `/accounts/${currentAccount.id}/documents/${documentId}/tags`,
          },
          config,
        ),
      )
    },
  },
  "documentTag/append": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, tags, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            data: { tags },
            url: `/accounts/${currentAccount.id}/documents/${documentId}/tags`,
          },
          config,
        ),
      )
    },
  },
  "documentTag/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, tagId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "DELETE",
            url: `/accounts/${currentAccount.id}/documents/${documentId}/tags/${tagId}`,
          },
          config,
        ),
      )
    },
  },
  // Contract tracking. Names match the API permission names, so isAllowed(name) reads the role.
  "documentContract/index": {
    required_login: true,
    required_workspace: true,
    fn: async (config = {}) => accountRequest("/contracts", config),
  },
  "documentContract/view": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, config = {}) => accountRequest(contractUrl(documentId), config),
  },
  "documentContract/update": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, data, config = {}) =>
      accountRequest(contractUrl(documentId), { ...config, method: "PUT", data }),
  },
  "documentContract/renew": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, data, config = {}) =>
      accountRequest(contractUrl(documentId, "/renew"), { ...config, method: "POST", data }),
  },
  "documentContract/terminate": {
    required_login: true,
    required_workspace: true,
    fn: async (documentId, data, config = {}) =>
      accountRequest(contractUrl(documentId, "/terminate"), { ...config, method: "POST", data }),
  },
  "tag/index": {
    required_login: true,
    required_workspace: true,
    fn: async (config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            url: `/accounts/${currentAccount.id}/tags`,
          },
          config,
        ),
      )
    },
  },
  "tag/create": {
    required_login: true,
    required_workspace: true,
    fn: async (name, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            data: { name },
            url: `/accounts/${currentAccount.id}/tags`,
          },
          config,
        ),
      )
    },
  },
  "tag/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (tagId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "DELETE",
            url: `/accounts/${currentAccount.id}/tags/${tagId}?force=true`,
          },
          config,
        ),
      )
    },
  },
  "document/upload": {
    required_login: true,
    required_workspace: true,
    fn: async (formData, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: formData,
            url: `/accounts/${currentAccount.id}/documents`,
          },
          config,
        ),
      )
    },
  },
  "document/fromTemplate": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, formData, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            data: formData,
            url: `/accounts/${currentAccount.id}/templates/${templateId}/documents`,
          },
          config,
        ),
      )
    },
  },
  "template/upload": {
    required_login: true,
    required_workspace: false,
    fn: async (formData, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            headers: {
              "Content-Type": "multipart/form-data",
            },
            data: formData,
            url: `/accounts/${currentAccount.id}/templates`,
          },
          config,
        ),
      )
    },
  },
  "template/index": {
    required_login: true,
    required_workspace: true,
    fn: async (config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            url: `/accounts/${currentAccount.id}/templates`,
          },
          config,
        ),
      )
    },
  },
  "template/view": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            url: `/accounts/${currentAccount.id}/templates/${templateId}`,
          },
          config,
        ),
      )
    },
  },
  "template/update": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, formData) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance({
        method: "PUT",
        url: `/accounts/${currentAccount.id}/templates/${templateId}`,
        data: JSON.stringify(formData),
      })
    },
  },
  "template/delete": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }
      return axiosInstance(
        Object.assign(
          {
            method: "DELETE",
            url: `/accounts/${currentAccount.id}/templates/${templateId}`,
          },
          config,
        ),
      )
    },
  },
  "template/updateFields": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, formData) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance({
        method: "PUT",
        url: `/accounts/${currentAccount.id}/templates/${templateId}/fields`,
        data: JSON.stringify(formData),
      })
    },
  },
  "templateRole/create": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, formData, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            data: formData,
            url: `/accounts/${currentAccount.id}/templates/${templateId}/roles`,
          },
          config,
        ),
      )
    },
  },
  "templateRole/update": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, roleId, formData, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            data: formData,
            url: `/accounts/${currentAccount.id}/templates/${templateId}/roles/${roleId}`,
          },
          config,
        ),
      )
    },
  },
  "templateRole/delete": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, roleId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

            return axiosInstance(
                Object.assign(
                    {
                        method: "DELETE",
                        url: `/accounts/${currentAccount.id}/templates/${templateId}/roles/${roleId}`,
                    },
                    config
                )
            );
        },
    },
    "subscription/view": {
        required_login: true,
        required_workspace: false,
        fn: async (accountId, config = {}) => {
            const sessionAccount = getSession()?.accounts?.[0];
            const id = accountId ?? sessionAccount?.id;
            if (!id) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${id}/subscription`,
                    },
                    config
                )
            );
        },
    },
    "subscription/update": {
        required_login: true,
        required_workspace: true,
        fn: async (formData) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance({
                method: "PUT",
                url: `/accounts/${currentAccount.id}/subscription`,
                data: JSON.stringify(formData),
            });
        },
    },
    "subscription/upgradePreview": {
        required_login: true,
        required_workspace: true,
        fn: async (planId, config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount || !planId) {
                return;
            }

            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/subscription/upgrade-preview`,
                        params: { plan_id: planId },
                    },
                    config
                )
            );
        },
    },
    "subscription/updatePaymentMethod": {
        required_login: true,
        required_workspace: true,
        fn: async (formData) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance({
                method: "PUT",
                url: `/accounts/${currentAccount.id}/subscription/payment-method`,
                data: JSON.stringify(formData),
            });
        },
    },
    "subscription/cancelPending": {
        required_login: true,
        required_workspace: true,
        fn: async (config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance(
                Object.assign(
                    {
                        method: "POST",
                        url: `/accounts/${currentAccount.id}/subscription/cancel-pending`,
                    },
                    config
                )
            );
        },
    },
    "subscription/pendingPix": {
        required_login: true,
        required_workspace: true,
        fn: async (config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/subscription/pending-payment/pix`,
                    },
                    config
                )
            );
        },
    },
    "subscription/terminate": {
        required_login: true,
        required_workspace: false,
        fn: async (accountId) => {
            if (!accountId) {
                return;
            }

            return axiosInstance({
                method: "POST",
                url: `/accounts/${accountId}/subscription/terminate`,
            });
        },
    },
     "credit/purchase": {
        required_login: true,
        required_workspace: true,
        fn: async (formData) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance({
                method: "POST",
                url: `/accounts/${currentAccount.id}/credits/purchase`,
                data: JSON.stringify(formData),
            });
        },
    },
    "customer/view": {
        required_login: true,
        required_workspace: false,
        fn: async (config = {}) => {
             const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/customer`,
                    },
                    config
                )
            );
        },
    },
    "customer/update": {
        required_login: true,
        required_workspace: true,
        fn: async (formData) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance({
                method: "PUT",
                url: `/accounts/${currentAccount.id}/customer`,
                data: JSON.stringify(formData),
            });
        },
    },
    "payment/index": {
        required_login: true,
        required_workspace: false,
        fn: async (config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/payments`,
                    },
                    config
                )
            );
        },
    },
    "credit/history": {
        required_login: true,
        required_workspace: false,
        fn: async (config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/credits/history`,
                    },
                    config
                )
            );
        },
    },
    "creditCard/index": {
        required_login: true,
        required_workspace: false,
        fn: async (config = {}) => {
             const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/credit-cards`,
                    },
                    config
                )
            );
        },
    },
    "creditCard/create": {
        required_login: true,
        required_workspace: true,
        fn: async (formData) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

            return axiosInstance({
                method: "POST",
                url: `/accounts/${currentAccount.id}/credit-cards`,
                data: JSON.stringify(formData),
            });
        },
    },
    "coupon/validate": {
        required_login: true,
        required_workspace: true,
        fn: async (couponCode, config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/accounts/${currentAccount.id}/coupons/validate`,
                        params: {
                            code: couponCode,
                        },
                    },
                    config
                )
            );
        },
    },
    "coupon/redeem": {
        required_login: true,
        required_workspace: true,
        fn: async (couponCode, config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }
            return axiosInstance(
                Object.assign(
                    {
                        method: "POST",
                        url: `/accounts/${currentAccount.id}/coupons/redeem`,
                        data: JSON.stringify({
                            code: couponCode,
                        }),
                    },
                    config
                )
            );
        },
    },
    "plan/index": {
        required_login: true,
        required_workspace: false,
        fn: async (config = {}) => {
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: "/plans",
                    },
                    config
                )
            );
        },
    },
    "plan/view": {
        required_login: true,
        required_workspace: false,
        fn: async (planId, config = {}) => {
            return axiosInstance(
                Object.assign(
                    {
                        method: "GET",
                        url: `/plans/${planId}`,
                    },
                    config
                )
            );
        },
    },
    "signer/theme": {
        required_login: false,
        required_workspace: false,
        fn: async (signerAccessCode) => {
            return axiosInstance({
                method: "GET",
                url: "/sign/theme",
                params: {
                    "signer-access-code": signerAccessCode,
                },
            });
        },
    },
    "signer/viewDocument": {
        required_login: false,
        required_workspace: false,
        fn: async (signerAccessCode, config = {}) => {
            return axiosInstance(
                Object.assign(
                    {
                        params: {
                            "signer-access-code": signerAccessCode,
                        },
                        url: "/sign",
                    },
                    config
                )
            );
        },
    },
    "signer/resendCertifiedCopy": {
        required_login: false,
        required_workspace: false,
        fn: async (signerAccessCode, config = {}) => {
            return axiosInstance(
                Object.assign(
                    {
                        method: "POST",
                        params: {
                            "signer-access-code": signerAccessCode,
                        },
                        url: "/sign/certified-copy",
                    },
                    config
                )
            );
        },
    },
    "signer/resendExpiredCertifiedCopy": {
        required_login: false,
        required_workspace: false,
        fn: async (token, config = {}) => {
            return axiosInstance(
                Object.assign(
                    {
                        method: "POST",
                        url: `/signers/downloads/${encodeURIComponent(token)}/resend`,
                    },
                    config
                )
            );
        },
    },
    "signer/verifyCode": {
        required_login: false,
        required_workspace: false,
        fn: async (signerAccessCode, verificationCode) => {
            return axiosInstance({
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                url: "/verify",
                data: {
                    "verification-code": verificationCode,
                    "signer-access-code": signerAccessCode,
                },
            });
        },
    },
    "signer/index": {
        required_login: true,
        required_workspace: false,
        fn: async (config = {}) => {
            const currentAccount = getSession().accounts[0];
            if (!currentAccount) {
                return;
            }

      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${currentAccount.id}/signers`,
          },
          config,
        ),
      )
    },
  },
  "signer/view": {
    required_login: true,
    required_workspace: false,
    fn: async (signerId, config = {}) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${currentAccount.id}/signers/${signerId}`,
          },
          config,
        ),
      )
    },
  },
  "signer/document": {
    required_login: false,
    required_workspace: false,
    fn: async (signerId, signerAccessCode, config = {}) => {
      const { params: extraParams, ...rest } = config
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/signers/${signerId}/document`,
            params: Object.assign(
              { "signer-access-code": signerAccessCode },
              extraParams || {},
            ),
          },
          rest,
        ),
      )
    },
  },
  "signer/documents": {
    required_login: true,
    required_workspace: false,
    fn: async (signerId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/signers/${signerId}/documents`,
          },
          config,
        ),
      )
    },
  },
  "signer/documentsSearch": {
    required_login: true,
    required_workspace: false,
    fn: async (signerId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/signers/${signerId}/documents/search`,
          },
          config,
        ),
      )
    },
  },
  "signer/create": {
    required_login: true,
    required_workspace: true,
    fn: async (formData) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance({
        method: "POST",
        url: `/accounts/${currentAccount.id}/signers`,
        data: JSON.stringify(formData),
      })
    },
  },
  "signer/update": {
    required_login: true,
    required_workspace: true,
    fn: async (signerId, formData) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance({
        method: "PUT",
        url: `/accounts/${currentAccount.id}/signers/${signerId}`,
        data: JSON.stringify(formData),
      })
    },
  },
  "signer/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (signerId) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }

      return axiosInstance({
        method: "DELETE",
        url: `/accounts/${currentAccount.id}/signers/${signerId}`,
      })
    },
  },
  "field/fieldTypesIndex": {
    required_login: true,
    required_workspace: false,
    fn: async (config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            type: "GET",
            url: "/field-types",
          },
          config,
        ),
      )
    },
  },
  "field/index": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/fields`,
          },
          config,
        ),
      )
    },
  },
  "field/view": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, fieldId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/fields/${fieldId}`,
          },
          config,
        ),
      )
    },
  },
  "field/update": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, fieldId, formData) =>
      axiosInstance({
        method: "PUT",
        url: `/accounts/${accountId}/fields/${fieldId}`,
        data: JSON.stringify(formData),
      }),
  },
  "field/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, fieldId) =>
      axiosInstance({
        method: "DELETE",
        url: `/accounts/${accountId}/fields/${fieldId}`,
      }),
  },
  "field/create": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, formData) =>
      axiosInstance({
        method: "POST",
        url: `/accounts/${accountId}/fields`,
        data: JSON.stringify(formData),
      }),
  },
  "field/validate": {
    required_login: false,
    required_workspace: true,
    fn: async (accountId, fieldId, value, signerAccessCode) =>
      axiosInstance({
        method: "POST",
        url: `/accounts/${accountId}/fields/${fieldId}/validate`,
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify({ value }),
      }),
  },
  "field/validateMultiple": {
    required_login: false,
    required_workspace: true,
    fn: async (accountId, values, signerAccessCode) =>
      axiosInstance({
        method: "POST",
        url: `/accounts/${accountId}/fields/validate-multiple`,
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify(values),
      }),
  },
  "assignment/create": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, entries) =>
      axiosInstance({
        method: "POST",
        url: `/documents/${documentId}/assignments`,
        data: JSON.stringify(entries),
      }),
  },
  "assignment/resend": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, assignmentId, signerId) =>
      axiosInstance({
        method: "PUT",
        url: `/documents/${documentId}/assignments/${assignmentId}/signers/${signerId}/resend`,
      }),
  },
  "assignment/estimateResendCost": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, assignmentId, signerId) =>
      axiosInstance({
        method: "POST",
        url: `/documents/${documentId}/assignments/${assignmentId}/signers/${signerId}/estimate-resend-cost`,
      }),
  },
  "assignment/identityVerificationReviewData": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, assignmentId, signerId) =>
      axiosInstance({
        method: "GET",
        url: `/documents/${documentId}/assignments/${assignmentId}/signers/${signerId}/identity-verification`,
      }),
  },
  "assignment/identityVerificationImage": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, assignmentId, signerId, imageName) =>
      axiosInstance({
        method: "GET",
        url: `/documents/${documentId}/assignments/${assignmentId}/signers/${signerId}/identity-verification/images/${encodeURIComponent(imageName)}`,
        responseType: "blob",
      }),
  },
  "assignment/reviewIdentityVerification": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, assignmentId, signerId, payload) =>
      axiosInstance({
        method: "POST",
        url: `/documents/${documentId}/assignments/${assignmentId}/signers/${signerId}/identity-verification/review`,
        data: JSON.stringify(payload),
      }),
  },
  "assignment/estimateCost": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, payload) =>
      axiosInstance({
        method: "POST",
        url: `/documents/${documentId}/assignments/estimate-cost`,
        data: JSON.stringify(payload),
      }),
  },
  "template/estimateDocumentCost": {
    required_login: true,
    required_workspace: false,
    fn: async (templateId, payload) => {
      const currentAccount = getSession().accounts[0]
      if (!currentAccount) {
        return
      }
      return axiosInstance({
        method: "POST",
        url: `/accounts/${currentAccount.id}/templates/${templateId}/documents/estimate-cost`,
        data: JSON.stringify(payload),
      })
    },
  },
  "activity/index": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, config = {}) => {
      const { params = {}, ...requestConfig } = config
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/documents/${documentId}/activities`,
            params: {
              page: 1,
              "per-page": 50,
              ...params,
            },
          },
          requestConfig,
        ),
      )
    },
  },
  "accountUser/addAccount": {
    required_login: true,
    required_workspace: false,
    fn: async (data, callback) => {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "POST",
          url: "/accounts",
          data: JSON.stringify(data),
        })
          .then((resp) => {
            if (resp.status === 200) {
              updateAccounts(resp, resolve, callback)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  "accountUser/index": {
    required_login: true,
    required_workspace: false,
    fn: async (config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: "/accounts",
          },
          config,
        ),
      )
    },
  },
  "account/view": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}`,
          },
          config,
        ),
      )
    },
  },
  "account/theme": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/theme`,
          },
          config,
        ),
      )
    },
  },
  "account/pendingActions": {
    required_login: true,
    required_workspace: false,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/pending-actions`,
          },
          config,
        ),
      )
    },
  },
  "account/pendingActionResolve": {
    required_login: true,
    required_workspace: false,
    fn: async (accountId, actionId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: `/accounts/${accountId}/pending-actions/${actionId}/resolve`,
          },
          config,
        ),
      )
    },
  },
  "account/update": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, data, callback) => {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "PUT",
          url: `/accounts/${accountId}`,
          data: JSON.stringify(data),
        })
          .then((resp) => {
            if (resp.status === 200) {
              updateAccounts(resp, resolve, callback)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  "account/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, callback, options = {}) => {
      const params = {}
      if (options.force) {
        params.force = true
      }

      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "DELETE",
          url: `/accounts/${accountId}`,
          params,
        })
          .then((resp) => {
            if (resp.status === 200) {
              updateAccounts(resp, resolve, callback)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  "accountUser/leave": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, callback) => {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "PUT",
          url: `/accounts/${accountId}/leave`,
        })
          .then((resp) => {
            if (resp.status === 200) {
              updateAccounts(resp, resolve, callback)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  "account/uploadLogo": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, formData) =>
      axiosInstance({
        method: "POST",
        url: `/accounts/${accountId}/logo`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }),
  },
  "account/deleteLogo": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId) =>
      axiosInstance({
        method: "DELETE",
        url: `/accounts/${accountId}/logo`,
      }),
  },
  "accountUser/memberIndex": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/members`,
          },
          config,
        ),
      )
    },
  },
  "authorization/assignRole": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, formData) =>
      axiosInstance({
        method: "POST",
        url: `/accounts/${accountId}/assign-role`,
        data: JSON.stringify(formData),
      }),
  },
  "authorization/revokeRole": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, formData) =>
      axiosInstance({
        method: "POST",
        url: `/accounts/${accountId}/revoke-role`,
        data: JSON.stringify(formData),
      }),
  },
  "signer/uploadSignature": {
    required_login: false,
    required_workspace: false,
    fn: async (blob, signerAccessCode, signatureType = "signature", reuse) => {
      const params = {
        "signer-access-code": signerAccessCode,
        type: signatureType,
      }

      if (reuse !== undefined) {
        params.reuse = reuse
      }

      return axiosInstance({
        method: "POST",
        url: "/signature",
        headers: {
          "Content-Type": "image/png",
        },
        params,
        data: blob,
      })
    },
  },
  "signer/signature": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode, signatureType = "signature") => {
      return axiosInstance({
        method: "GET",
        url: `/signature/${signatureType}`,
        responseType: "blob",
        params: {
          "signer-access-code": signerAccessCode,
        },
      })
    },
  },
  "signer/signItems": {
    required_login: false,
    required_workspace: false,
    fn: async (documentId, assignmentId, signedData, signerAccessCode) =>
      axiosInstance({
        method: "POST",
        url: `/documents/${documentId}/assignments/${assignmentId}`,
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify(signedData),
      }),
  },
  // Assinatura com Certificado Digital A1/A3 (ICP-Brasil) via Lacuna Web PKI.
  // `start` inicia a assinatura no Rest PKI e devolve o token; o browser assina
  // localmente com esse token (a chave privada nunca sai da máquina) e `complete`
  // finaliza a assinatura PAdES e avança o fluxo. Ambos autenticam pelo
  // signer-access-code, igual aos demais endpoints do link de assinatura.
  "signer/certificateStart": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode) =>
      axiosInstance({
        method: "POST",
        url: "/signers/certificate/start",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify({ "signer-access-code": signerAccessCode }),
      }),
  },
  "signer/certificateComplete": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode, token) =>
      axiosInstance({
        method: "POST",
        url: "/signers/certificate/complete",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify({ "signer-access-code": signerAccessCode, token }),
      }),
  },
  "authentication/requestPasswordReset": {
    required_login: false,
    required_workspace: false,
    fn: async (data) =>
      axiosInstance({
        method: "PUT",
        url: "/authentication/request-password-reset",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      }),
  },
  "authentication/changePassword": {
    required_login: true,
    required_workspace: false,
    fn: async (data) =>
      axiosInstance({
        method: "PUT",
        url: "/authentication/change-password",
        data: JSON.stringify(data),
      }),
  },
  "authentication/resetPassword": {
    required_login: false,
    required_workspace: false,
    fn: async (data) =>
      axiosInstance({
        method: "PUT",
        url: "/authentication/reset-password",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      }),
  },
  "authentication/mfaVerify": {
    required_login: false,
    required_workspace: false,
    fn: async (formData) => {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "POST",
          url: "/authentication/mfa/verify",
          data: formData,
        })
          .then((resp) => setSession(resp, resolve))
          .catch(reject)
      })
    },
  },
  "accountUser/userIndex": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/users`,
          },
          config,
        ),
      )
    },
  },
  "user/getSelf": {
    required_login: true,
    required_workspace: false,
    fn: async (config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: "/users/self",
          },
          config,
        ),
      )
    },
  },
  "user/updateSelf": {
    required_login: true,
    required_workspace: false,
    fn: async (formData, config = {}, callback) => {
      return new Promise((resolve, reject) => {
        return axiosInstance(
          Object.assign(
            {
              method: "PUT",
              url: "/users/self",
              data: JSON.stringify(formData),
            },
            config,
          ),
        )
          .then((resp) => {
            selfUpdates(callback)

            resolve(resp)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  "user/updateInterest": {
    required_login: true,
    required_workspace: false,
    fn: async (interest, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: "/users/self/interest",
            data: JSON.stringify({ interest }),
          },
          config,
        ),
      )
    },
  },
  "user/updatePlan": {
    required_login: true,
    required_workspace: false,
    fn: async (plan, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: "/users/self/plan",
            data: JSON.stringify({ plan }),
          },
          config,
        ),
      )
    },
  },
  "user/deleteSelf": {
    required_login: true,
    required_workspace: false,
    fn: async (formData, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "DELETE",
            url: "/users/self",
            data: JSON.stringify(formData),
          },
          config,
        ),
      )
    },
  },
  "user/cancelDeleteSelf": {
    required_login: true,
    required_workspace: false,
    fn: async (formData, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: "/users/self/cancel-delete",
            data: JSON.stringify(formData),
          },
          config,
        ),
      )
    },
  },
  "accountUser/userView": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, userId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/users/${userId}`,
          },
          config,
        ),
      )
    },
  },
  "user/create": {
    required_login: false,
    required_workspace: false,
    fn: async (formData) => {
      return new Promise((resolve, reject) => {
        return axiosInstance({
          method: "POST",
          url: "/users",
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify(formData),
        })
          .then((resp) => {
            setSession(resp, resolve)
          })
          .catch((error) => {
            clearSession()
            reject(error)
          })
      })
    },
  },
  "accountUser/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, userId) =>
      axiosInstance({
        method: "DELETE",
        url: `/accounts/${accountId}/users/${userId}`,
      }),
  },
  "user/deleteReasons": {
    required_login: true,
    required_workspace: false,
    fn: async () =>
      axiosInstance({
        method: "GET",
        url: "/users/delete-reasons",
      }),
  },
  "userInvitation/fulfill": {
    required_login: false,
    required_workspace: false,
    fn: async (invitationId, formData) => {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "POST",
          url: `/user-invitations/${invitationId}/fulfill`,
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify(formData),
        })
          .then((resp) => {
            resolveAuthentication(resp, resolve)
          })
          .catch((error) => {
            clearSession()
            reject(error)
          })
      })
    },
  },
  "user/verifyEmail": {
    required_login: false,
    required_workspace: false,
    fn: async (data) =>
      axiosInstance({
        method: "PUT",
        url: "/users/verify-email",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(data),
      }),
  },
  "user/requestEmailVerification": {
    required_login: true,
    required_workspace: false,
    fn: async (data) =>
      axiosInstance({
        method: "PUT",
        url: "/users/request-email-verification",
        data: JSON.stringify(data),
      }),
  },
  "userInvitation/create": {
    required_login: true,
    required_workspace: false,
    fn: async (formData) =>
      axiosInstance({
        method: "POST",
        url: "/user-invitations",
        data: JSON.stringify(formData),
      }),
  },
  "userInvitation/view": {
    required_login: false,
    required_workspace: false,
    fn: async (invitationId) =>
      axiosInstance({
        method: "GET",
        url: `/user-invitations/${invitationId}`,
      }),
  },
  "userInvitation/delete": {
    required_login: true,
    required_workspace: false,
    fn: async (invitationId) =>
      axiosInstance({
        method: "DELETE",
        url: `/user-invitations/${invitationId}`,
      }),
  },
  "signer/self": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode) =>
      axiosInstance({
        method: "GET",
        url: "/signers/self",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
      }),
  },
  "signer/identityVerification": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode, config = {}) =>
      axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: "/signers/identity-verification",
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              "signer-access-code": signerAccessCode,
            },
          },
          config,
        ),
      ),
  },
  "signer/identityVerificationStart": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode) =>
      axiosInstance({
        method: "POST",
        url: "/signers/identity-verification",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify({ consent: true }),
      }),
  },
  "signer/acceptTerms": {
    required_login: false,
    required_workspace: false,
    fn: async (signerAccessCode) =>
      axiosInstance({
        method: "PUT",
        url: "/signers/accept-terms",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
      }),
  },
  "signer/confirmData": {
    required_login: false,
    required_workspace: false,
    fn: async (documentId, data, signerAccessCode) =>
      axiosInstance({
        method: "PUT",
        url: `/documents/${documentId}/signers/confirm-data`,
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify(data),
      }),
  },
  "signer/rejectAssignment": {
    required_login: false,
    required_workspace: false,
    fn: async (documentId, assignmentId, data, signerAccessCode) =>
      axiosInstance({
        method: "PUT",
        url: `/documents/${documentId}/assignments/${assignmentId}/reject`,
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify(data),
      }),
  },
  "signer/declineMultiple": {
    required_login: false,
    required_workspace: false,
    fn: async (documentIds, assignmentId, data, signerAccessCode) =>
      axiosInstance({
        method: "PUT",
        url: "/signers/documents/decline-multiple",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify(
          Object.assign({
            document_ids: documentIds,
            ...data,
          }),
        ),
      }),
  },
  "signer/signMultiple": {
    required_login: false,
    required_workspace: false,
    fn: async (documentIds, signerAccessCode) =>
      axiosInstance({
        method: "PUT",
        url: "/signers/documents/sign-multiple",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          "signer-access-code": signerAccessCode,
        },
        data: JSON.stringify({
          document_ids: documentIds,
        }),
      }),
  },
  "assignment/resetExpiration": {
    required_login: true,
    required_workspace: false,
    fn: async (documentId, assignmentId, data) =>
      axiosInstance({
        method: "PUT",
        url: `/documents/${documentId}/assignments/${assignmentId}/reset-expiration`,
        data: JSON.stringify(data),
      }),
  },
  "authorization/permissionIndex": {
    required_login: false,
    required_workspace: true,
    fn: async (accountId) =>
      axiosInstance({
        method: "GET",
        url: `/accounts/${accountId}/permissions`,
      }),
  },
  "socialLogin/login": {
    required_login: false,
    required_workspace: false,
    fn: async (credentials) => {
      return new Promise((resolve, reject) => {
        axiosInstance({
          method: "POST",
          url: "/authentication/social-login",
          data: credentials,
        })
          .then((resp) => {
            resolveAuthentication(resp, resolve)
          })
          .catch((error) => {
            clearSession()
            reject(error)
          })
      })
    },
  },
  "user/mfaIndex": {
    required_login: true,
    required_workspace: false,
    fn: async (config = {}) =>
      axiosInstance({
        method: "GET",
        url: "/users/self/mfa",
        ...config,
      }),
  },
  "user/mfaTotpCreate": {
    required_login: true,
    required_workspace: false,
    fn: async (formData = {}) =>
      axiosInstance({
        method: "POST",
        url: "/users/self/mfa/totp",
        data: formData,
      }),
  },
  "user/mfaTotpConfirm": {
    required_login: true,
    required_workspace: false,
    fn: async (formData) =>
      axiosInstance({
        method: "PUT",
        url: "/users/self/mfa/totp/confirm",
        data: formData,
      }),
  },
  "user/mfaRecoveryCodes": {
    required_login: true,
    required_workspace: false,
    fn: async (formData) =>
      axiosInstance({
        method: "POST",
        url: "/users/self/mfa/recovery-codes",
        data: formData,
      }),
  },
  "user/mfaDelete": {
    required_login: true,
    required_workspace: false,
    fn: async (methodId, formData) =>
      axiosInstance({
        method: "DELETE",
        url: `/users/self/mfa/${methodId}`,
        data: formData,
      }),
  },
  "user/generateApiKey": {
    required_login: true,
    required_workspace: false,
    fn: async (formData) =>
      axiosInstance({
        method: "POST",
        url: "/users/api-keys",
        data: JSON.stringify(formData),
      }),
  },
  "user/viewApiKey": {
    required_login: true,
    required_workspace: false,
    fn: async (config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: "/users/api-keys",
          },
          config,
        ),
      )
    },
  },
  "webhook/eventTypes": {
    required_login: true,
    required_workspace: true,
    fn: async (config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: "/webhooks/event-types",
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/index": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/webhooks/endpoints`,
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/create": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, formData, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            url: `/accounts/${accountId}/webhooks/endpoints`,
            data: JSON.stringify(formData),
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/view": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, endpointId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/webhooks/endpoints/${endpointId}`,
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/update": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, endpointId, formData, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: `/accounts/${accountId}/webhooks/endpoints/${endpointId}`,
            data: JSON.stringify(formData),
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/delete": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, endpointId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "DELETE",
            url: `/accounts/${accountId}/webhooks/endpoints/${endpointId}`,
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/secret": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, endpointId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/webhooks/endpoints/${endpointId}/secret`,
          },
          config,
        ),
      )
    },
  },
  "webhook-endpoint/rotate-secret": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, endpointId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            url: `/accounts/${accountId}/webhooks/endpoints/${endpointId}/secret/rotate`,
          },
          config,
        ),
      )
    },
  },
  "webhook/update": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, formData, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: `/accounts/${accountId}/webhooks/subscriptions`,
            data: JSON.stringify(formData),
          },
          config,
        ),
      )
    },
  },
  "webhook/index": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/webhooks/subscriptions`,
          },
          config,
        ),
      )
    },
  },
  "webhook/inactivate": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "PUT",
            url: `/accounts/${accountId}/webhooks/inactivate`,
          },
          config,
        ),
      )
    },
  },
  "webhook/logs": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "GET",
            url: `/accounts/${accountId}/webhooks`,
          },
          config,
        ),
      )
    },
  },
  "webhook/resend": {
    required_login: true,
    required_workspace: true,
    fn: async (accountId, webhookId, config = {}) => {
      return axiosInstance(
        Object.assign(
          {
            method: "POST",
            url: `/accounts/${accountId}/webhooks/${webhookId}/retry`,
          },
          config,
        ),
      )
    },
  },
  "signer/downloadDocument": {
    required_login: false,
    required_workspace: false,
    fn: async (signerId, documentId, artifactName, signerAccessCode) =>
      axiosInstance({
        method: "GET",
        url: `/signers/${signerId}/documents/${documentId}/download/${artifactName}`,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "blob",
        params: {
          "signer-access-code": signerAccessCode,
        },
      }),
  },
  "publicDocument/view": {
    required_login: false,
    required_workspace: false,
    fn: async (document_id) => {
        axiosInstance({
            method: "GET",
            url: `/public/documents/${document_id}`,
        })
    },
  },
  "publicDocument/sendToken": {
    required_login: false,
    required_workspace: false,
    fn: async (document_id, data) => {
      return axiosInstance({
        method: "PUT",
        url: `/public/documents/${document_id}/send-token`,
        data,
      })
    },
  },
}

const Api = (name) => {
  const Endpoint = Endpoints[name]

  if (!Endpoint) {
    return
  }

  const hasWorkspace = getSession()?.accounts?.[0]?.id

  if (
    getPermissions(name) ||
    !Endpoint.required_login ||
    (!getPermissions(name) && !Endpoint.required_workspace) ||
    (Endpoint.required_workspace && hasWorkspace)
  ) {
    return Endpoint.fn
  }

  return () =>
    new Promise((resolve, reject) => {
      reject({
        response: {
          data: {
            message: "Você não tem permissão ou endpoint não foi encontrado",
          },
        },
      })
    })
}

const deleteAccount = (allowed) => {
  const endpoint = allowed ? "account/delete" : "accountUser/leave"

  return (accountId, callback, options = {}) =>
    Endpoints[endpoint].fn(accountId, callback, options)
}

export {
  Api,
  clearSession,
  deleteAccount,
  downloadFile,
  downloadFileBlob,
  getSession,
  isAllowed,
  setSession,
  login,
  selectAccount,
  selfUpdates,
  updateAccounts,
  updateSession,
  urlWithAccessToken,
  urlWithSignerAccessCode,
}
